"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLandActivityTypeByKey = exports.land_activity_type_list = exports.land_activity_types = void 0;
const util_1 = require("./util");
exports.land_activity_types = [
    { key: 'land_owner', tupuake_id: 1, display_name: 'Land Owner' },
    { key: 'holder_of_lease', tupuake_id: 2, display_name: 'Holder of Registered Lease' },
    { key: 'crown_conservation', tupuake_id: 3, display_name: 'Crown Conservation Land' },
];
exports.land_activity_type_list = exports.land_activity_types.map((sp) => sp.key);
exports.getLandActivityTypeByKey = (0, util_1.createFindByKeyUsingArray)(exports.land_activity_types, 'land_activity_type');
